export const atsplans = [
  {
    name: "Starter",
    description: "For beginners",
    monthlyPrice: 0,
    yearlyPrice: 0,
    features: ["Up to 3 Resume", "10GB storage", "Email support"],
    popular: false,
    color: "#06b6d4",
  },
  {
    name: "Growth",
    description: "Perfect for individuals getting started",
    monthlyPrice: 8.99,
    yearlyPrice: 90,
    features: [
      "Up to 100 Resumes per month",
      "10GB storage",
      "Email support",
      "Basic analytics",
      "Advanced keyword suggestions",
    ],
    popular: true,
    color: "#6366f1",
  },
  {
    name: "Scale",
    description: "Ideal for growing businesses",
    monthlyPrice: 14.99,
    yearlyPrice: 150,
    features: [
      "Up to 500 resumes per month",
      "50GB storage",
      "Everything in Growth plan",
      "Priority support",
      "Advanced analytics",
      "Team collaboration",
    ],
    popular: false,
    color: "#8b5cf6",
  },
];

export const atsPlansStyle = {
  container: {
    padding: "100px 20px",
    paddingBottom: "25px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    marginBottom: "60px",
    color: "#1f2937",
  },
  title: {
    fontFamily: "DM Sans",
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "16px",
    color: "black",
  },
  subtitle: {
    fontSize: "18px",
    color: "#000",
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: "1.6",
  },
  billingToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "50px",
    gap: "20px",
  },
  toggleContainer: {
    position: "relative",
    backgroundColor: "#f8fafc",
    borderRadius: "50px",
    padding: "4px",
    display: "flex",
    border: "1px solid #e5e7eb",
  },
  toggleButton: {
    padding: "12px 24px",
    borderRadius: "46px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "0.95rem",
    fontWeight: "500",
    border: "none",
    backgroundColor: "transparent",
    color: "#6b7280",
  },
  toggleButtonActive: {
    backgroundColor: "#006bff",
    color: "#ffffff",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
  },
  badge: {
    backgroundColor: "#22c55e",
    color: "#ffffff",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "0.8rem",
    fontWeight: "600",
    marginLeft: "10px",
  },
  plansGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "24px",
    maxWidth: "1200px",
    margin: "0 auto",
    // padding: "0 16px",
    "@media (min-width: 640px)": {
      gap: "30px",
      padding: "0",
    },
    "@media (min-width: 1024px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  planCard: {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "40px 30px",
    position: "relative",
    transition: "all 0.3s ease",
    border: "1px solid #6366f1",
    cursor: "pointer",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
    display: "flex",
    flexDirection: "column",
  },
  planCardPopular: {
    background:
      "linear-gradient(to bottom right, #f7f8fe, #f0f8ff, #fff, #ffa95337)",
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
    color: "#000",
  },
  popularBadge: {
    position: "absolute",
    top: "-12px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#ff8000",
    color: "#fff",
    padding: "8px 24px",
    borderRadius: "20px",
    fontSize: "0.85rem",
    fontWeight: "600",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    border: "1px solid #e2e8f0",
  },
  planName: {
    fontSize: "1.75rem",
    fontWeight: "700",
    marginBottom: "8px",
    color: "#1f2937",
  },
  planDescription: {
    color: "#6b7280",
    marginBottom: "30px",
    fontSize: "1rem",
    lineHeight: "1.5",
  },
  priceContainer: {
    marginBottom: "30px",
  },
  price: {
    fontSize: "3rem",
    fontWeight: "800",
    color: "#1f2937",
    lineHeight: "1",
  },
  currency: {
    fontSize: "1.5rem",
    fontWeight: "600",
  },
  period: {
    fontSize: "1rem",
    color: "#6b7280",
    fontWeight: "500",
  },
  savings: {
    fontSize: "0.85rem",
    color: "#22c55e",
    fontWeight: "600",
    marginTop: "8px",
  },
  featuresList: {
    listStyle: "none",
    padding: 0,
    marginBottom: "40px",
  },
  featureItem: {
    padding: "12px 0",
    color: "#374151",
    display: "flex",
    alignItems: "center",
    fontSize: "0.95rem",
    borderBottom: "1px solid #f3f4f6",
  },
  checkIcon: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#22c55e",
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "#ffffff",
    flexShrink: 0,
  },
  ctaButton: {
    fontFamily: "DM Sans",
    width: "100%",
    padding: "12px 24px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
  },
  primaryButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    boxShadow: "0 8px 20px rgba(102, 126, 234, 0.4)",
  },
  secondaryButton: {
    backgroundColor: "transparent",
    color: "#000",
    border: "1px solid #000",
  },
};
